import { useTrackPublicPageEvents } from "../misc/useTrackPublicPageEvents";

export enum EventType {
  CHERRY_CHECK_ELIGIBILITY_CLICKED = "Cherry Check Eligibility Clicked",
  AFFIRM_LEARN_MORE_CLICKED = "Affirm Learn More Clicked",
  LEARN_MORE_ABOUT_PAYMENT_PLANS_CLICKED = "Learn More About Payment Plans Clicked",
}
export const useClientPortalPaymentPlansMixpanelEvents = (medspaId: string) => {
  return useTrackPublicPageEvents<EventType>(medspaId);
};
